module.exports = {
      id: "logos:seekvolunteer-inverse-usage",
      viewBox: "0 0 249 48",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#logos:seekvolunteer-inverse-usage",
      toString: function () {
        return this.url;
      }
    }